import Modal from '../../../base/pages/consumption/Modal';

const modal: Modal = {
  noDataTitle: 'Vybrané rozmezí neobsahuje žádná data',
  noDataMessage: ''
};

export default modal;
